/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {useSelector} from 'react-redux'
import NoMatchWithAuth from './no-match-with-auth'
import NoMatchWithoutAuth from './no-match-without-auth'

const NoMatch = () => {
  const {uid} = useSelector(state => state.firebase.auth)

  // Unauthorized user accessed non-existing route
  if (!uid) return <NoMatchWithoutAuth />

  // Authorized user accessed non-existing route
  return <NoMatchWithAuth />
}

export default NoMatch
